module.exports = __webpack_public_path__ + "static/img/btn.6c38fc95.svg";